import { createSlice } from "@reduxjs/toolkit";

export const currentDateState = {
  currentDate: "",
};

const CurrentDateSlice = createSlice({
  name: "currentDate",
  initialState: currentDateState,
  reducers: {
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
  },
});

export const CurrentDateActions = {
  ...CurrentDateSlice.actions,
};

export default CurrentDateSlice.reducer;
